"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateOrganizationMemberInvitationResult = exports.UpdateOrganizationMemberInvitationPayload = void 0;
const class_validator_1 = require("class-validator");
const base_update_result_dto_1 = require("../../../../common/dtos/base-update-result.dto");
class UpdateOrganizationMemberInvitationPayload {
}
__decorate([
    (0, class_validator_1.IsUUID)(),
    (0, class_validator_1.IsOptional)()
], UpdateOrganizationMemberInvitationPayload.prototype, "organizationMemberRoleId", void 0);
exports.UpdateOrganizationMemberInvitationPayload = UpdateOrganizationMemberInvitationPayload;
class UpdateOrganizationMemberInvitationResult extends base_update_result_dto_1.BaseUpdateResult {
}
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)()
], UpdateOrganizationMemberInvitationResult.prototype, "organizationMemberInvitation", void 0);
exports.UpdateOrganizationMemberInvitationResult = UpdateOrganizationMemberInvitationResult;
